export default "__VITE_ASSET__BcqRyas4__"